function init_summeranim(from_php){
    var main=$(".place.summeranim");
    var obj=main.find("#canvMain");
    var conf=$.takeGirlConf(from_php.girl_id,"girlownanim_png")["summer"];
    var girlName=$.takeGirlImage(from_php.girl_id);
    var imagesObj={
        "1":{
            conf:{period_min:50,period_max:50},
            arr:[
                {
                    path:_IMG_SERV+"/gfx/place/summeranim/anim/"+girlName+"/anim.png",
                    conf:$.extend({width: 512, height: 512, left: 100, top: 50, clips: 12},conf)
                }
            ]
        }
    };
    main.find("#water").qAnim({width:1141,clips:17,loop:1});
    var pont=main.find("#pontoon");
    function pontoonAnim(){
        var range_arr,step=0,step_max=0,inc=1,dir=inc,pos=[],side=0;
        
        function init_anim(){
            if(side==1){
                side=-1;
                return false;
            }
            side=1;
            var r_x=mt_rand(10,20),r_y=mt_rand(10,20);
            range_arr=[r_x,r_y];
            step_max=50;
            return true;
        }
        init_anim();
        _moduleTimeHandler.add(function(){
            step+=dir;
            if(step>=step_max){
                step=step_max;
                dir=-inc;
            }
            if(step<=0){
                step=0;
                dir=inc;
                init_anim();
            }
            pos[0]=Math.round(range_arr[0]*step/step_max)*side;
            pos[1]=Math.round(range_arr[1]*step/step_max);
            pont.css({"margin-top":pos[1]+"px","margin-left":pos[0]+"px"});
            
        },40);
    }
    pontoonAnim();
    var back=main.find("#back");
    function backAnim(){
        var step=0,step_max=120,dir=1,inc=1,pos=[],range_arr=[-20,20];
        _moduleTimeHandler.add(function(){
            step+=dir;
            if(step>=step_max){
                step=step_max;
                dir=-inc;
            }
            if(step<=0){
                step=0;
                dir=inc;
            }
            pos[0]=range_arr[0]+step/step_max*(range_arr[1]-range_arr[0]);
            back.css({"margin-left":pos[0]+"px"});
            
        },30);
    }
    backAnim();
    
    obj.off("was_loaded").one("was_loaded",function(){
        obj.animCircleLoop("start");
        var anim_name=_mySound.playSound("girl_play");
        _moduleEvents.on("moduleClear",function(){
            _mySound.stopSound(anim_name);
        });

    }).animCircleLoop({},imagesObj,_moduleTimeHandler);
    
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
    
}